<template>
  <div id="app" class="auth-portal-app">
    <!-- 全局加载指示器 -->
    <div v-if="loading" class="global-loading">
      <el-icon class="is-loading">
        <Loading />
      </el-icon>
      <span>正在加载...</span>
    </div>

    <!-- 路由视图 -->
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

    <!-- 全局消息提示 -->
    <GlobalMessage />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import GlobalMessage from '@/components/common/GlobalMessage.vue'

export default {
  name: 'App',
  components: {
    GlobalMessage
  },
  setup() {
    const store = useStore()
    
    // 全局加载状态
    const loading = computed(() => store.state.app.loading)

    return {
      loading
    }
  },
  created() {
    console.log('🎯 Auth Portal App Created')
    
    // 检查认证状态
    this.$store.dispatch('auth/checkAuthStatus')
    
    // 监听网络状态
    this.setupNetworkListener()
  },
  methods: {
    setupNetworkListener() {
      window.addEventListener('online', () => {
        this.$store.commit('app/SET_NETWORK_STATUS', true)
      })
      
      window.addEventListener('offline', () => {
        this.$store.commit('app/SET_NETWORK_STATUS', false)
      })
    }
  }
}
</script>

<style lang="scss">
// 全局重置样式
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f7fa;
}

#app {
  height: 100%;
  overflow: hidden;
}

// 全局加载样式
.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  
  .el-icon {
    font-size: 32px;
    color: #409eff;
    margin-bottom: 16px;
  }
  
  span {
    color: #666;
    font-size: 14px;
  }
}

// 路由过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style> 